import { render, staticRenderFns } from "./TasksByStatus.vue?vue&type=template&id=64479975&scoped=true"
import script from "./TasksByStatus.vue?vue&type=script&lang=js"
export * from "./TasksByStatus.vue?vue&type=script&lang=js"
import style0 from "./TasksByStatus.vue?vue&type=style&index=0&id=64479975&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64479975",
  null
  
)

export default component.exports